import React, {
  FunctionComponent,
  ReactElement,
  useContext,
  useEffect,
  useState
} from 'react';
import { useCookies } from 'react-cookie';
import cookieIcon from '../assets/images/cookie.svg';
import { AppStore } from '../store/app.context';
import styles from './withCookieBar.module.scss';

export function withCookieBar(Component: FunctionComponent): FunctionComponent {
  const CookieBarWrapper: FunctionComponent<{}> = (props): ReactElement => {
    const { state } = useContext(AppStore);
    const [forceClose, setForceClose] = useState(true);
    const [cookies, setCookie] = useCookies();
    const { buttonCta, agreementText } = state.cookieSection;

    useEffect(() => {
      setForceClose(cookies.cookieAgreement);
    }, [cookies]);

    return (
      <div className={styles.siteWrapper}>
        <Component {...props} />
        {!forceClose && (
          <div className={styles.cookieBarWrapper}>
            <div className={styles.cookieBar}>
              <img
                src={cookieIcon}
                alt="cookie icon"
                className={styles.cookieIcon}
              />
              <p>
                {agreementText}
                <button
                  onClick={(): void => setCookie('cookieAgreement', true)}
                  className={styles.acceptButton}
                >
                  {buttonCta}
                </button>
              </p>

              <button
                className={styles.close}
                onClick={(): void => setCookie('cookieAgreement', true)}
              >
                <span className={styles.closeCross} />
                <span className={styles.closeCross} />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };
  return CookieBarWrapper;
}
